import React from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { IApplicationState } from 'components/store/types'
import { getRegionCliniques } from 'components/core/state/selectors'
import Slider from 'components/ui/abstract/Slider'
import Container from 'components/ui/Container'
import GoogleMapWrapper from 'components/maps/GoogleMapWrapper'
import { css, StyleSheet } from 'aphrodite'
import { IClinique } from 'components/core/types'
import CliniqueBlock from 'components/ui/CliniqueBlock'
import { AppDispatch } from 'components/store/state/store'
import { updateMapActiveMarker } from 'components/core/state/actions'

const mapState = (state: IApplicationState) => ({
  cliniques: getRegionCliniques(state),
})
const mapDispatch = (dispatch: AppDispatch) => ({
  updateMapMarker: (markerId: number) => dispatch(updateMapActiveMarker(markerId)),
})
const connector = connect(mapState, mapDispatch)

const Step2MapMobile = ({ cliniques, updateMapMarker }: ConnectedProps<typeof connector>) => {
  const handleBeforeChange = (currentValue, newValue) => {
    console.log('handleBeforeChange', cliniques[newValue]?.id)
    updateMapMarker(cliniques[newValue]?.id)
  }
  return (
    <>
      <div className="tw-w-full">
        <GoogleMapWrapper />
      </div>
      <Container>
        <div className="tw-col-span-12 tw-mt-5">
          <Slider cliniques={cliniques} onBeforeChange={handleBeforeChange}>
            {cliniques.map((clinique: IClinique) => (
              <div className={css(styles.container)} key={clinique.id}>
                <CliniqueBlock clinique={clinique} fullLink={false} />
              </div>
            ))}
          </Slider>
        </div>
      </Container>
    </>
  )
}
const styles = StyleSheet.create({
  container: {
    minWidth: '80vw',
  },
})
export default connector(Step2MapMobile)
